document.addEventListener("DOMContentLoaded", () => {
  initCountdown();
  initFaqAccordions();
  initFloatingCta();
});

/**
 * 1. Urgency Countdown Timer
 * Counts down to the end of the current day to create a realistic, dynamic urgency effect.
 */
function initCountdown() {
  const hoursVal = document.getElementById("sl-hours");
  const minsVal = document.getElementById("sl-mins");
  const secsVal = document.getElementById("sl-secs");

  if (!hoursVal || !minsVal || !secsVal) return;

  function updateTimer() {
    const now = new Date();
    // Set target time to midnight tonight (end of today)
    const target = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59
    );
    
    let diff = target - now;

    // If somehow past target, reset to next day's end
    if (diff < 0) {
      diff += 24 * 60 * 60 * 1000;
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    hoursVal.textContent = String(hours).padStart(2, '0');
    minsVal.textContent = String(minutes).padStart(2, '0');
    secsVal.textContent = String(seconds).padStart(2, '0');
  }

  updateTimer();
  setInterval(updateTimer, 1000);
}

/**
 * 2. FAQ Accordion Panels
 */
function initFaqAccordions() {
  const accordionItems = document.querySelectorAll(".sl-accordion-item");

  accordionItems.forEach(item => {
    const trigger = item.querySelector(".sl-accordion-trigger");
    const panel = item.querySelector(".sl-accordion-panel");

    if (!trigger || !panel) return;

    trigger.addEventListener("click", () => {
      const isActive = item.classList.contains("sl-active");
      
      // Close all other items first
      accordionItems.forEach(otherItem => {
        otherItem.classList.remove("sl-active");
        const otherPanel = otherItem.querySelector(".sl-accordion-panel");
        const otherTrigger = otherItem.querySelector(".sl-accordion-trigger");
        const otherIndicator = otherItem.querySelector(".sl-accordion-indicator");
        
        if (otherPanel) otherPanel.style.maxHeight = null;
        if (otherTrigger) otherTrigger.setAttribute("aria-expanded", "false");
        if (otherIndicator) {
          otherIndicator.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="sl-icon-plus"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>`;
        }
      });

      // Toggle current item
      if (!isActive) {
        item.classList.add("sl-active");
        panel.style.maxHeight = panel.scrollHeight + "px";
        trigger.setAttribute("aria-expanded", "true");
        const indicator = item.querySelector(".sl-accordion-indicator");
        if (indicator) {
          indicator.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="sl-icon-minus"><path d="M5 12h14"></path></svg>`;
        }
      } else {
        item.classList.remove("sl-active");
        panel.style.maxHeight = null;
        trigger.setAttribute("aria-expanded", "false");
        const indicator = item.querySelector(".sl-accordion-indicator");
        if (indicator) {
          indicator.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="sl-icon-plus"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>`;
        }
      }
    });
  });
}

/**
 * 3. Floating Mobile CTA Bar
 * Shows only on mobile when scrolled past the hero section (scroll threshold ~500px).
 */
function initFloatingCta() {
  const floatingBar = document.getElementById("sl-floating-bar");

  if (!floatingBar) return;

  function handleScroll() {
    const isMobile = window.innerWidth <= 1024;
    const isPastHero = window.scrollY > 450;

    if (isMobile && isPastHero) {
      floatingBar.classList.add("sl-visible");
    } else {
      floatingBar.classList.remove("sl-visible");
    }
  }

  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", handleScroll);
  handleScroll(); // Run once initially
}
